import { ExportAuditLogsRequest } from 'api';
import { AUDIT_LOGS } from 'common/endpoints';
import BaseServiceRetryWrapper from './baseRetry';

class AuditLogsService extends BaseServiceRetryWrapper {
  exportLogs = (data: ExportAuditLogsRequest): Promise<Blob> =>
    this.getFile<Blob, ExportAuditLogsRequest>(AUDIT_LOGS.exportLogs(), data);
}

export default AuditLogsService;
